import { HttpClient } from '@angular/common/http';
import { Injectable ,EventEmitter} from '@angular/core';
//import { AngularFirestore } from '@angular/fire/firestore';
//import { AngularFirestore } from 'angularfire2/firestore';
//import { AngularFireDatabase } from '@angular/fire/database';
//import { AngularFirestore, AngularFirestoreDocument , AngularFirestoreCollection } from 'angularfire2/firestore'
//import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFirestore } from 'angularfire2/firestore';
import { map } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
// import { SpotPage } from '../../pages/spot/spot';
// import { NavController , NavParams,IonicPage } from 'ionic-angular';

/* 
  Generated class for the DataProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class DataProvider {
  navToSpot = new BehaviorSubject({id:'',muzeum:'',exhibition:''});

  constructor(
    // public navCtrl: NavController,
    private af:AngularFirestore,public http: HttpClient) {


    console.log('Hello DataProvider Provider');
    


  }
  //ServerURL = "http://localhost:3000";
  ServerURL = "http://lm.experteam-game.co.il:3000";

lang='' ;
mdoalvoaopen=false;
currentPage = ''




fbTest(val){
  console.log('start firebase');
  return  this.af.collection('Exhibition',ref=>{
    return ref.where("lang","==",'he')
   }).snapshotChanges().pipe(
    map(actions => {
      return actions.map(a => {
     //   console.log('firebase-a',a);

        const data = a.payload.doc.data();
        const id = a.payload.doc.id;
       // console.log('firebase',data);

        return { id, ...data };
      });
    }));

}

backGroundCove="";
navigationC = {
  home:true,
  numType: false,
  more:false,
}
spotsList;

showPad = false;

  selectedExebition;
  menuShow = false;
  ExhibitionsService;
  NowLang;
  mapShow = false;
  direction = "ltr";
  spotType='';
  selectedSpot:any = {
    "id":"",
    _id: '',
    
  };

  Muzeum = {
    _id:"",
    id:"",
    lang:[{"code":"loading"}],
    urlCode:"",
    logo:"assets/imgs/logoDEF.png",
    ExhibitionStyle:"",
    settings: { fontClass: '', 
    type:'',
    showlistex:'false'},
    borderRadius: '',
    border: '',
    boxShadow:'',
    exTextStyle:'',
    background:'',
    
  }
  // Muzeum =
  //   {
  //     "_id": "5b93bae8c8445104910ae283",
  //     "defaultLang": "he",
  //     "urlCode":"ComicsHolon",
  //     "ExhibitionStyle":"option2",
  //     "lang": [
  //       {
  //         "code": "en",
  //         "direction": "ltr",
  //         "name": "comics holon",
  //         "discription": "bla bla bla bla"
  //       }
  //     ],
  //     "logo": "src/ihiu/oijoi.png",
  //     "username": "holonComics",
  //     "password": "isajdoiaj",
  //     "link": "http://muses.com/holonvlalal",
  //     "advPop": {},
  //     "settings": {}
  //   };

selectedSpotExe;


modalVoa(){


     this.mdoalvoaopen=true;

   }


setLocalStorage(name,val){
  localStorage.setItem(name, val);
  return true;
}

getLocalStorage(name){
  return localStorage.getItem(name);
}

setStatstic(type){
  
 
  this.af.collection('logs').add({
    type:type,
    userwork: localStorage.getItem('userwork') ? localStorage.getItem('userwork') : 'no-user',

    muzeum: this.Muzeum.id ?this.Muzeum.id : '',
    muzeumName: this.Muzeum.urlCode ? this.Muzeum.urlCode :'',
    time:  new Date(),
    lang:this.lang ? this.lang :'',
    spotid:this.selectedSpotExe ? this.selectedSpotExe :'',
    spotcode:this.selectedSpot.code?this.selectedSpot.code:'',
    spotname:this.selectedSpot.name ? this.selectedSpot.name:'',
    ExhibitionsID:this.selectedSpot.ExhibitionsID ? this.selectedSpot.ExhibitionsID :'',
  })
  
  
}

    // http://localhost:3000/api/ExhibitionByLang/5b93bae8c8445104910ae283/he
    getExhibitionByLang(id,lang){
      console.log('getExhibitionByLang');
      console.log(this.ServerURL + "/api/ExhibitionByLang/" + id + "/"+ lang)
      return this.http.get(this.ServerURL + "/api/ExhibitionByLang/" + id + "/"+ lang);
    }
    

    // http://localhost:3000/api/spotID/5b96684e174f465f8f200b68
    getSpotByID(id){
      console.log('getSpotByID',id);
      return this.http.get(this.ServerURL + "/api/spotID/" + id);
    }

    
    // http://localhost:3000/api/Exhibition/5b93bc0fc8445104910ae284
    getExhibitionByID(DOMid){
      console.log('getExhibitionByID',DOMid);
      return this.http.get(this.ServerURL + "/api/Exhibition/" + DOMid);
    }

    // http://localhost:3000/api/spot/5b93bc0fc8445104910ae284/222/en
    getSpotByExebitionCodeAndLang(id,code,lang){
      console.log('getSpotByExebitionCodeAndLang',id,code,lang);
      return this.http.get(this.ServerURL + "/api/spot/" + id + "/" + code + "/"+ lang);
    }

   // http://localhost:3000/api/Muzeum/ComicsHolon
    getMuzeumByurlCode(urlCode){
      console.log('getMuzeumByurlCode');
      return this.http.get(this.ServerURL + "/api/Muzeum/" + urlCode);
    }




    getSpotByExebitionCodeAndLangFB(id,code,lang){
      console.log('getSpotByExebitionCodeAndLang',id,code,lang);

      return  this.af.collection('spots',ref=>{
        return ref.where("muzeum","==",id).where("code","==",code).where("lang","==",lang)
       }).snapshotChanges().pipe(
        map(actions => {
          return actions.map(a => {
            const data:any = a.payload.doc.data();
            const id = a.payload.doc.id;
            data.id = id;
            data._id = id;

            console.log('getExhibitionByLangFB-firebase',data);
            console.log('getExhibitionByLangFB-firebase',id);
            return { id, ...data };
          });
        }));


   //   return this.http.get(this.ServerURL + "/api/spot/" + id + "/" + code + "/"+ lang);
    }



    getExhibitionByLangFB(id,lang){
      console.log('getMuzeumByurlCode');
      return  this.af.collection('Exhibition',ref=>{
        return ref.where("muzeum","==",id).where("lang","==",lang)
       }).snapshotChanges().pipe(
        map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data();
            const id = a.payload.doc.id;
            console.log('getExhibitionByLangFB-firebase',data);
            return { id, ...data };
          });
        }));
    }

 choosenEx:any;
 ExhibitionFBcol = this.af.collection('Exhibition');
 FBcol = this.af;


 getSpotsByExhibitionIDFB(DOMid){
  console.log('getSpotsByExhibitionIDFB',DOMid);
  return  this.af.collection('spots',ref=>{
    return ref.where("ExhibitionsID","==",DOMid)
   }).snapshotChanges().pipe(
    map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data();
        const id = a.payload.doc.id;
        console.log('firebase',data);
        return { id, ...data };
      });
    }));
 }


    getExhibitionByIDFB(DOMid){
      console.log('getExhibitionByIDFB',DOMid);
       this.af.collection('Exhibition').doc(DOMid).ref.get().then(function(doc) {
        if (doc.exists) {
            console.log("Document data:", doc.data());
            this.choosenEx = doc.data();
        } else {
            console.log("No such document!");
            return {status:false};

        }
      }).catch(function(error) {
          console.log("Error getting document:", error);
      });
    
    //  return  this.af.collection('Exhibition').doc(DOMid).valueChanges();

    }



    getMuzeumByurlCodeFB(urlCode){
      console.log('getMuzeumByurlCode',urlCode);
      return  this.af.collection('muzeums',ref=>{
        return ref.where("urlCode","==",urlCode)
       }).snapshotChanges().pipe(
        map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data();
            const id = a.payload.doc.id;
            console.log('firebase',data);
            return { id, ...data };
          });
        }));
    }


    // get the current lang
    getMuzeumData(lang){
      console.log('getMuzeumData',lang);
      console.log('this.Muzeum',this.Muzeum);
      let  langFrom
      langFrom = this.Muzeum.lang.filter(element => element.code == lang);
      console.log('langFrom',langFrom);

      this.direction = langFrom[0].direction;
    
      let returnItem =  langFrom[0];
     // console.log(this.Muzeum.boxShadow);
      returnItem["ExhibitionStyle"]=this.Muzeum.ExhibitionStyle;
      returnItem["borderRadius"]=this.Muzeum.borderRadius;
      returnItem["border"]=this.Muzeum.border;
      returnItem["boxShadow"]=this.Muzeum.boxShadow;
      returnItem["exTextStyle"]=this.Muzeum.exTextStyle;
      returnItem["background"]=this.Muzeum.background;
      return returnItem;
    }

}



// WEBPACK FOOTER //
// ./src/providers/data/data.ts